"use client";

import { SelectSuite } from "@padi/suites/select";
import { CropGrid } from "@padi/shared/crops/_components/crop-listing";
import { useCrops } from "../_hooks/use-crops";
import { useCropsContext } from "../_context";
import { sortOptions } from "../_consts";
function SortDropdown() {
  const { filters, updateFilter } = useCropsContext();

  const handleSortChange = (value: string) => {
    updateFilter("sortBy", value);
  };

  return (
    <SelectSuite
      placeholder="Most Recent"
      options={sortOptions}
      value={filters.sortBy || "recent"}
      onValueChange={handleSortChange}
      className="w-48 h-14 bg-accent text-accent-foreground data-[placeholder]:text-accent-foreground [&_svg:not([class*='text-'])]:text-accent-foreground"
    />
  );
}

export function CropListings() {
  const { currentPage, apiFilters } = useCropsContext();
  const cropGridProps = useCrops({
    pageSize: 12,
    currentPage,
    apiFilters,
  });
  return (
    <div className="bg-white h-full">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl lg:text-3xl font-bold text-primary">
          Browse Available Crops
        </h2>
        <div className="flex flex-col sm:flex-row items-center space-x-2">
          <p className="text-xl text-foreground">Sort by:</p>
          <SortDropdown />
        </div>
      </div>

      {/* Crop Grid */}
      <CropGrid query={cropGridProps} />
    </div>
  );
}
